<template>
   <div class="container px-0 bg-danger">
   <div class="offcanvas offcanvas-end rounded-2 shadow bg-light" 
         data-bs-scroll="true" 
         data-bs-backdrop="false" 
         tabindex="-1" 
         id="offcanvasCopy" 
         aria-labelledby="offcanvasCopyLabel"
      >
      <!--
      -->
      <div class="offcanvas-header">
         <h6 id="offcanvasCopyLabel">Copiar Tarjeta ({{cnttId}})</h6>
         <button 
            id="bttCloseOcCopyTo"
            type="button" 
            class="btn-close btn-sm text-reset" 
            data-bs-dismiss="offcanvas" 
            aria-label="Close" 
            ref="btn_out_offcanvas"
            ></button>
      </div>
      <hr class="m-0"/>
      <div class="offcanvas-body gap-0">
         <b class="tc-gray fs-12">Titulo</b>
         <textarea 
            v-model="dataToCopy.title"
            class="form-control bg-light tc-d-gray fs-14 my-1" 
            rows="3"
            :readonly="titleByForm"
         >
         </textarea>
         <!--
         {{titleByForm}}
         -->
         <b class="tc-gray fs-12">Conservar</b>
         <div 
               v-for="(item, index) in dataToCopy.items" 
               :key="index" 
               class="row row-cols-2"
               >
            <div class="col-1">
               <input type="checkbox" 
                  class="form-check-input" 
                  :checked="item.checked"
                  @click="checkItem(index)"
               >
            </div>
            <div class="col-11 pb-2">
               <div class="tc-d-gray fs-14">{{item.name}}</div>
            </div>
         </div>
         <b class="tc-gray fs-12">Copiar en</b>
         <!--
         {{dataToCopy}}
            <button class="btn btn-primary" :disabled="coping" @click="copyTo()">
         -->
         <select v-model="copyPicked" class="form-select mt-1">
            <option v-for="(cell, index) in cells" :key="index" :value="cell.id">
               {{ cell.name }}
            </option>
         </select>
         <div class="d-grid py-2">
            <button class="btn btn-primary" :disabled="coping" @click="doNotClose = true"> <!-- :disabled="sorting || !newSort" @click="doSort()" > -->
               <span v-show="coping" class="spinner-border spinner-border-sm"></span>
               {{txtBttCopy}}
            </button>
         </div>
         <!--
         -->
      </div>
         <!--
         -->
   </div>
   </div>
   <do-not-close  v-if="doNotClose"
      :messages="[
            'No cierre esta pantalla, espere a que vuelva a aparecer la pantalla anterior.',
            'Esto permitirá terminar correctamente la copia de esta tarjeta.'
            ]"
      @onOpened="copyTo()"
      />
</template>

<script>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'

import WspService from "../workSpace.service";
import DoNotClose from './form/DoNotClose.vue';

export default {
   components: {
      DoNotClose
   },
   setup() {
      const store = useStore()
      const cnttId = ref(store.state.wspace.contentId)
      const boardId = ref(null)
      const btn_out_offcanvas = ref(null)
      const cellId = ref(0)
      const cellContentId = ref(0)
      const cells = ref([])
      const copyPicked = ref('')
      const copyTitle = ref('')
      const coping = ref(false)
      const dataToCopy = ref({})
      const txtBttCopy = ref('')
      const message = ref({})
      const titleByForm = ref(false)

      const doNotClose = ref(false)

      onMounted(() => {
         let myOffCanvas = document.getElementById('offcanvasCopy')
         myOffCanvas.addEventListener('shown.bs.offcanvas', function (event) {
         console.log(store.state.wspace.contentId)
         cnttId.value = store.state.wspace.contentId
            let button = event.relatedTarget
            cellId.value = button.getAttribute('data-cell-id')
            cellContentId.value = button.getAttribute('data-cellContent-id')
            titleByForm.value = button.getAttribute('data-title-by-form') == "true"
         coping.value = false
         txtBttCopy.value = 'Copiar'
         boardId.value = WspService.getBoardId(store)
         getDataToCopy(boardId.value, cnttId.value)
         getCellsByBoard()
         copyPicked.value = cellId.value
         message.value = {}
         myOffCanvas.focus()
         console.log(" show copy's OC")
         })
         console.log("copy's OC")
      })

      function checkItem(index) {
         let checked = dataToCopy.value.items[index].checked
         dataToCopy.value.items[index].checked = !checked
      }

      function getCellsByBoard() {
         WspService.getCellsByBoard(boardId.value)
         .then(response => {
            //console.log(response.data)
            // //cells.value = response.data
            cells.value = []
            let allCells = response.data
            for ( let i = 0; i < allCells.length; i++ ) {
               if ( allCells[i].canCardsInOut ) {
                  //console.log(allCells[i].name)
                  cells.value.push(allCells[i])
               }
               //state.sortParameters = [sortParam,...state.sortParameters];
            }
         })
         .catch(error => {
            console.log(error);
         });
      }
      
      function getDataToCopy(boardId, contentId) {
         WspService.getDataToCopy(boardId, contentId)
         .then(response => {
            dataToCopy.value = response.data
            dataToCopy.value.cellId = copyPicked
            dataToCopy.value.userId = store.state.auth.user.id
            dataToCopy.value.boardId = boardId.value
         })
         .catch(error => {
            console.log(error);
         });
      }

      function focusOff() {
         let timer = 1;
         let interval = setInterval(() => {
         if (timer === 0) {
            clearInterval(interval)                
         } else {
            timer--
            if (copyPicked.value == cellId.value)
               btn_out_offcanvas.value.click()
         }             
         }, 125)
      }

      function copyTo() {
         dataToCopy.value.boardId = boardId.value
         dataToCopy.value.titleByForm = titleByForm.value
         coping.value = true
         txtBttCopy.value = 'Copiando'
         /*
         focusOff()
         doNotClose.value = true
         */
         WspService.upDataToCopy(dataToCopy)
         .then(response => {
            console.log(response.data)
            message.value = response.data
            if ( message.value.statusCode != 0 ) {
               alert( message.value.message )
            }
            store.dispatch("wspace/setContentId", -10)
         })
         .catch( error => { console.log(error) } )
         .finally( () => { 
            console.log('Copia Tarjeta Finalizada!!') 
            doNotClose.value = false
            btn_out_offcanvas.value.click()
         })
         /*
               WspService.upForm( {freeText: "Copy", contentId: 100} )
               .then( response => {
                  console.log( response.data )
               })
               .catch( error => { console.log(error) } )
               .finally( () => { 
                  console.log('Copia Tarjeta Finalizada!!') 
                  doNotClose.value = false
                  btn_out_offcanvas.value.click()
               })
         */
      }

      return {
         btn_out_offcanvas,
         focusOff,
         cellId,
         cells,
         checkItem,
         cnttId,
         copyPicked,
         copyTitle,
         copyTo,
         coping,
         dataToCopy, doNotClose,
         message,
         titleByForm,
         txtBttCopy,
      }
   }
}
</script>

<style scoped>
.offcanvas-end {
  top: 50px;
  right: 5%;
  width: 350px;
  height: fit-content;
}
/*
  right: 100px;
*/
.btn-info {
   background-color: #e5e7e9;
   border-color: #e5e7e9 ;
}
.btn-info:hover {
   background-color:  #cacfd2 ;
}
.btn-sm {
   width: max-content;
}
.fp-bg-color {
  width: 60px;
  height: 40px;
}
.fp-onOff {
  width: 333px;
  height: 30px;
  text-align: center;
}
.tc-gray {
   color: gray;
}
.tc-d-gray {
   color: darkslategray;
}
.fs-11 {
   font-size: 11px;
}
.fs-12 {
   font-size: 12px;
}
.fs-14 {
   font-size: 14px;
}
</style>